import { RenderTypingIndicator } from './druid/types/TypingIndicatorMiddleware';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useRenderTypingIndicator(): RenderTypingIndicator {
  return useWebChatAPIContext().typingIndicatorRenderer;
}
